module.exports = __webpack_public_path__ + "img/stock.f5ab16e6.png";